import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Translation from '@checkout-s/Translation';

class FeeDisclosure extends PureComponent {
    render() {
        if (!this.props.message || (Array.isArray(this.props.message) && !this.props.message.length) || this.props.message === "") {
            return null;
        }
        if(Array.isArray(this.props.message)){
          return <p className="fee-disclosure__message">{this.renderFeeDisclosure()}</p>;
        }
        return <p className="fee-disclosure__message">{this.props.message}</p>;
    }

    renderFeeDisclosure = () => {
        const hasMultiple = this.props.message.length > 1;
        if(!hasMultiple && (this.props.message[0] === "" || !this.props.message[0])) {
            return null;
        } else if(hasMultiple) {
            const stringMix = this.props.message.join(', ');
            if(stringMix === "" || !stringMix) {
                return null;
            }
        }
        const stub = !hasMultiple
            ? 'checkout__fee_will_be_applied_to_order'
            : 'checkout__fees_will_be_applied_to_order';
        const interpolation = {
            feeString: !hasMultiple
                ? this.props.message[0]
                : this.props.message.join(', ')
        };
        return (
            <Translation interpolation={interpolation}>
                {stub}
            </Translation>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        message: state.ui && state.ui.checkoutConfig && state.ui.checkoutConfig.feeDisclosureMessage ? state.ui.checkoutConfig.feeDisclosureMessage : null,
    };
}

export default connect(mapStateToProps)(FeeDisclosure)
